import React, { useState } from "react"
import { cn, ELEMENTS, randoms } from "lib/utils"
import { RenderLayout } from "lib/components"


export default function BuilderModal({
  open=false,
  closeFn=() => null,
  selectFn=() => null,
  selectedElement=null
}:{
  open?:boolean;
  closeFn?:() => void
  selectFn?: (selectedElem:any) => void
  selectedElement:any
}){

  const [ selections, setSelections ] = useState<any>({ component: null, showTitle: false, title: ""})

  const handleSelectElement = (e:any) => {
    const chosen = ELEMENTS.find((elem:any) => elem.refstr === e.target.value)
    setSelections({ ...selections, component: chosen?.refstr, title: chosen?.title })
  }

  const handleSaveChanges = () => {
    selectFn({...selections})
    closeFn()
  }

  if (!open) return <></>
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 m-auto w-[28rem] flex justify-center items-center z-50">
      <div className="bg-slate-700 p-3">
        <h2 className="text-lg font-semibold mb-2">Configure Block</h2>
        <div className="w-full flex flex-col justify-start items-start gap-3">

          <div className="w-full flex flex-col gap-1">
            <label className="block text-xs uppercase">Choose an element for this area</label>
            <select className="w-full bg-transparent border border-solid border-slate-400 px-2 py-1 rounded-sm text-white text-sm focus:outline-none focus:border-slate-400" onChange={handleSelectElement}>
              <option className="bg-slate-800 text-white" value="">Select Element</option>
              { ELEMENTS
                .sort( (a:any, b:any) => {
                  if( a.title < b.title ) return -1
                  if( a.title > b.title ) return 1
                  return 0
                })
                .map((elem:any) => (
                <option key={elem.refstr} value={elem.refstr} className="bg-slate-800 text-white">
                  {elem.title}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full flex flex-col gap-1">
            <label className="block text-xs uppercase">Show Title</label>
            <div className="w-full flex justify-evenly items-center gap-3">
              <button className="w-full text-sm bg-green-800 text-white px-2 py-[4px]">Yes</button>
              <button className="w-full text-sm bg-red-800 text-white px-2 py-[4px]">No</button>
            </div>
          </div>

          <div className="w-full flex flex-col gap-1">
            <label className="block text-xs uppercase">Title</label>
            <input 
              type="text"
              className="w-full bg-transparent border border-solid border-slate-400 px-2 py-1 rounded-sm text-white text-sm focus:outline-none focus:border-slate-400"
              value={selections.title || ""} 
              onChange={(e) => setSelections({ ...selections, title: e.target.value })} 
            />
          </div>

          <div className="w-full flex justify-end gap-2 mt-4">
            <button onClick={closeFn} className="bg-gray-500 text-white px-4 py-1 rounded-sm hover:bg-gray-600">
              Cancel
            </button>
            <button onClick={handleSaveChanges} className="bg-teal-800 text-white px-4 py-1 rounded-sm hover:bg-teal-900">
              Save Changes
            </button>
          </div>

        </div>
      </div>
    </div>
  )
}